/* eslint no-confusing-arrow: 0 */
import React from 'react';

import { Route, Redirect } from 'react-router-dom';

// eslint-disable-next-line import/no-cycle
import AuthorizedView from './AuthorizedView';

class AuthorizedRoute extends React.Component {
  render() {
    const { component: Component, render, authority, redirectPath, ...rest } = this.props;
    return (
      <AuthorizedView
        authority={authority}
        noMatch={<Route {...rest} render={() => <Redirect to={{ pathname: redirectPath }} />} />}
      >
        <Route {...rest} render={props => (Component ? <Component {...props} /> : render(props))} />
      </AuthorizedView>
    );
  }
}

export default AuthorizedRoute;
